<template>
  <div class="opaque-header">
    <q-tabs align="left" class="full-height text-subtitle-2 text-secondary-1" no-caps indicator-color="primary-1">
      <template v-for="tab of tabs">
        <q-route-tab
          :key="tab.id"
          :to="tab.route"
          :ripple="false"
          class="q-ml-lg q-px-sm"
          active-class="text-heading-2 text-secondary-3"
        >
          {{ tab.name }}
        </q-route-tab>

        <HelpPageBtn
          v-if="!!tab.page && $route.path.includes(tab.route)"
          :key="`guide-link-${tab.id}`"
          :page="tab.page"
        />
      </template>
    </q-tabs>
  </div>
</template>

<script>
import HelpPageBtn from '@/reusable/base-components/HelpPageBtn'

export default {
  components: {
    HelpPageBtn
  },

  props: {
    tabs: {
      type: Array,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
.opaque-header {
  ::v-deep .q-tabs__content {
    overflow: visible;

    .q-tab--inactive {
      opacity: 1 !important;
    }

    .q-tab__indicator {
      height: 3px;
      border-radius: 3px;
    }
  }
}
</style>
